function RecalcularCondiciones(Conditions, Preguntas){


    if (Conditions.length >= 1)
    {

        for (let Condition of Conditions)
        {
            
            let Pregunta = buscarPreguntaporCodigo(Condition["code"], Preguntas);


            if (Pregunta["status"] == "OK")
            {

                if (Pregunta["data"]["response"] != null){

                    

                    let tipo = Condition["condition"];
                    let RespuestaUsuario = Pregunta["data"]["response"];
                    let RespuestaDada = Condition["response"];

                    switch (tipo) {

                        case 'equal':

                            if (RespuestaUsuario == RespuestaDada)
                            {   


                                Preguntas = MostrarOcultarPreguntas(Condition["ShowsQuestions"], Preguntas, true);
                                Preguntas = MostrarOcultarPreguntas(Condition["HideQuestions"], Preguntas, false);

                            } else {



                                if (Condition["code"] != "PrecioProducto")
                                {

                                    Preguntas = MostrarOcultarPreguntas(Condition["ShowsQuestions"], Preguntas, false);
                                    Preguntas = MostrarOcultarPreguntas(Condition["HideQuestions"], Preguntas, true);

                                }


                            }
            
                            break;

                        case 'greater-than-or-equal-to':

                            if (RespuestaUsuario >= RespuestaDada)
                            {   


                                Preguntas = MostrarOcultarPreguntas(Condition["ShowsQuestions"], Preguntas, true);
                                Preguntas = MostrarOcultarPreguntas(Condition["HideQuestions"], Preguntas, false);

                            } else {


                                Preguntas = MostrarOcultarPreguntas(Condition["ShowsQuestions"], Preguntas, false);
                                Preguntas = MostrarOcultarPreguntas(Condition["HideQuestions"], Preguntas, true);

                            }
            
                            break;
                        default:

                    }




                }



            }


        }

        return Preguntas;


    } else {

        
        return Preguntas;


    }


    

}

function buscarPreguntaporCodigo(Codigo, Preguntas){

    for (let Pregunta of Preguntas)
    {

        if (Pregunta["code"] == Codigo)
        {

            let resultado = {

                status : "OK",
                data: Pregunta
            }

            return resultado;

        }

    }

    let resultado = {

        status : "KO"
    }

    return resultado;

}


function CambiarDisplayPreguntaporCodigo(Codigo, Preguntas, Display){


    for (let Orden in Preguntas)
    {

        if (Preguntas[Orden]["code"] == Codigo)
        {

            Preguntas[Orden]["show"] = Display;

        }


    }

    return Preguntas;

}

function MostrarOcultarPreguntas(Codigos, Preguntas, Display){


    for (let Codigo of Codigos)
    {

        Preguntas = CambiarDisplayPreguntaporCodigo(Codigo, Preguntas, Display);


    }

    return Preguntas;


}

exports.RecalcularCondiciones = RecalcularCondiciones;
exports.buscarPreguntaporCodigo = buscarPreguntaporCodigo;